import primaryButton from '../../../../primary-button';

const secondary = (params) => primaryButton.brandedSolid.background.disabled.secondary(params);

export default secondary;
